export const toDate = (ts: {
  seconds?: number;
  nanoseconds?: number;
  _seconds?: number;
  _nanoseconds?: number;
}): Date => {
  const seconds = ts.seconds ?? ts._seconds ?? 0;
  const nanos = ts.nanoseconds ?? ts._nanoseconds ?? 0;
  return new Date(seconds * 1000 + nanos / 1e6);
};


export const isDateInCurrentMonth = (
  dateParam: Date | string | number,
): boolean => {
  // Normalize input into a Date object
  const date = new Date(dateParam);
  if (isNaN(date.getTime())) {
    throw new Error("Invalid date parameter");
  }

  const now = new Date();

  const sameMonth = date.getMonth() === now.getMonth();
  const sameYear = date.getFullYear() === now.getFullYear();

  return sameMonth && sameYear;
};
